import * as React from 'react';
import * as styles from './styles.scss';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import classNames from 'classnames';
import colorMap from 'owa-timestream-asset-sdk-color/lib/colorMap';
import { generateColorScheme } from 'owa-color-utils/lib/colorUtils';
import { observer } from 'mobx-react-lite';
import { TxpPeekWrapper, TxpSource } from 'owa-txp';

export default observer(function TXPCalendarItemView({
    item,
    fullItem,
    popoutPane,
    DueDate,
    assetColor,
}: {
    item: CalendarItem;
    fullItem: Readonly<CalendarEvent>;
    popoutPane: () => void;
    DueDate?: React.ReactNode;
    assetColor?: string;
}) {
    const colorScheme = generateColorScheme(
        colorMap.filter(colorObj => assetColor == colorObj.color)[0]?.styleColor
    );

    //check for DueDate below is needed so that the div and its margins are not visible until a due date is set
    return (
        <div className={classNames(styles.calendarItemView, styles.isTXPView)}>
            {DueDate && <div className={styles.dueDateContainer}>{DueDate}</div>}
            <TxpPeekWrapper
                colorScheme={colorScheme}
                entityNamesMap={fullItem.EntityNamesMap as number}
                txpBlob={fullItem.TailoredXpEntities as string}
                txpLocation={item.Location}
                source={TxpSource.SpacesCalendar}
                onViewInMailClicked={popoutPane}
            />
        </div>
    );
});
